import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '/more/discover_family_engagement/dad_and_child_pic.jpg'
import _imports_1 from '/more/discover_family_engagement/My_Story.jpg'


const _hoisted_1 = { class: "mt-20" }
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12" }
const _hoisted_3 = { class: "flex items-center gap-4 mb-4" }
const _hoisted_4 = { class: "p-3 bg-pink-100 dark:bg-pink-900/30 rounded-lg" }
const _hoisted_5 = { class: "flex items-center gap-4 mb-4" }
const _hoisted_6 = { class: "p-3 bg-blue-100 dark:bg-blue-900/30 rounded-lg" }
const _hoisted_7 = { class: "flex items-center gap-4 mb-4" }
const _hoisted_8 = { class: "p-3 bg-green-100 dark:bg-green-900/30 rounded-lg" }
const _hoisted_9 = { class: "flex items-center gap-4 mb-4" }
const _hoisted_10 = { class: "p-3 bg-purple-100 dark:bg-purple-900/30 rounded-lg" }
const _hoisted_11 = { class: "flex items-center gap-4 mb-4" }
const _hoisted_12 = { class: "p-3 bg-orange-100 dark:bg-orange-900/30 rounded-lg" }
const _hoisted_13 = { class: "flex items-center gap-4 mb-4" }
const _hoisted_14 = { class: "p-3 bg-indigo-100 dark:bg-indigo-900/30 rounded-lg" }
const _hoisted_15 = { class: "grid grid-cols-1 md:grid-cols-2 gap-8" }
const _hoisted_16 = { class: "mt-20" }
const _hoisted_17 = { class: "flex flex-col md:flex-row gap-8 w-full mt-8" }

import { Motion } from "motion-v";


export default /*@__PURE__*/_defineComponent({
  __name: 'family-engagement',
  setup(__props) {

defineOgImage("MainOg", {
  title: "Family Engagement - Life Story Work & Parent Profiles",
  description:
    "Strengthen family connections with comprehensive life story work tools and detailed parent profiles. Keep families actively involved in their loved ones care journey.",
  theme: "#bc9fff",
  colorMode: "light",
});

useSeoMeta({
  title: "Family Engagement - Life Story Work & Parent Profiles | FamilyAxis",
  description:
    "Strengthen family connections with comprehensive life story work tools and detailed parent profiles. Keep families actively involved in their loved ones care journey.",
  keywords:
    "family assessment, family assessment centres, family engagement, life story work, parent profiles, family involvement, care home communication, family connections, relationship building",
  author: "FamilyAxis",
  ogTitle: "Family Engagement - Life Story Work & Parent Profiles | FamilyAxis",
  ogDescription:
    "Strengthen family connections with comprehensive life story work tools and detailed parent profiles. Keep families actively involved in their loved ones care journey.",
  ogUrl: "https://familyaxis.com/more/family-engagement",
  ogType: "website",
  ogSiteName: "FamilyAxis",
  twitterCard: "summary_large_image",
  twitterTitle: "Family Engagement - Life Story Work & Parent Profiles | FamilyAxis",
  twitterDescription:
    "Strengthen family connections with comprehensive life story work tools and detailed parent profiles.",
  twitterSite: "@familyaxis",
  robots: "index, follow",
});

useHead({
  link: [{ rel: "canonical", href: "https://familyaxis.com/more/family-engagement" }],
});

return (_ctx: any,_cache: any) => {
  const _component_UPageHeader = _resolveComponent("UPageHeader")!
  const _component_UPageHero = _resolveComponent("UPageHero")!
  const _component_UIcon = _resolveComponent("UIcon")!
  const _component_UCard = _resolveComponent("UCard")!
  const _component_UPageSection = _resolveComponent("UPageSection")!
  const _component_LazyShowCaseCard = _resolveComponent("LazyShowCaseCard")!
  const _component_LazyStartSignup = _resolveComponent("LazyStartSignup")!
  const _component_UPageBody = _resolveComponent("UPageBody")!
  const _component_UPage = _resolveComponent("UPage")!
  const _component_UContainer = _resolveComponent("UContainer")!

  return (_openBlock(), _createBlock(_component_UContainer, null, {
    default: _withCtx(() => [
      _createVNode(_component_UPage, { class: "pt-10" }, {
        default: _withCtx(() => [
          _createVNode(_component_UPageHeader, { description: "At FamilyAxis, we believe assessments should be more than paperwork — they should strengthen connections between parents, children, and professionals. Our Family Engagement tools are designed to make families feel seen, supported, and encouraged, even during difficult times." }),
          _createVNode(_component_UPageBody, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_UPageHero, {
                  title: "Comprehensive Family Engagement Features",
                  description: "Everything you need to keep families at the heart of assessment while meeting regulatory standards and creating meaningful connections.",
                  ui: {
              container: 'py-8 sm:py-6 lg:py-6',
              title: 'text-4xl sm:text-4xl text-pretty tracking-tight font-bold',
              // description: 'text-lg sm:text-xl/8 text-muted dark:text-neutral-300 max-w-180',
            }
                }),
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(Motion), {
                    as: "div",
                    initial: { opacity: 0, y: 20 },
                    "while-in-view": { opacity: 1, y: 0 },
                    viewport: { once: true },
                    transition: { duration: 0.4, delay: 0.1 }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UCard, { class: "p-6 hover:shadow-lg transition-all duration-300" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                              _createVNode(_component_UIcon, {
                                name: "i-heroicons-heart",
                                class: "h-6 w-6 text-pink-600 dark:text-pink-400"
                              })
                            ]),
                            _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "text-lg font-semibold" }, "Child-Centred Approach", -1))
                          ]),
                          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-gray-600 dark:text-gray-400" }, " Ensure the child remains at the centre of every assessment with dedicated tools that capture their voice, experiences, and milestones throughout their journey. ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Motion), {
                    as: "div",
                    initial: { opacity: 0, y: 20 },
                    "while-in-view": { opacity: 1, y: 0 },
                    viewport: { once: true },
                    transition: { duration: 0.4, delay: 0.2 }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UCard, { class: "p-6 hover:shadow-lg transition-all duration-300" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                              _createVNode(_component_UIcon, {
                                name: "i-heroicons-chat-bubble-left-right",
                                class: "h-6 w-6 text-blue-600 dark:text-blue-400"
                              })
                            ]),
                            _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "text-lg font-semibold" }, "Flexible Feedback Forms", -1))
                          ]),
                          _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-gray-600 dark:text-gray-400" }, " Create simple, friendly feedback forms that highlight achievements, capture special moments, and provide continuous records of progress for reports and reviews. ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Motion), {
                    as: "div",
                    initial: { opacity: 0, y: 20 },
                    "while-in-view": { opacity: 1, y: 0 },
                    viewport: { once: true },
                    transition: { duration: 0.4, delay: 0.3 }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UCard, { class: "p-6 hover:shadow-lg transition-all duration-300" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(_component_UIcon, {
                                name: "i-heroicons-book-open",
                                class: "h-6 w-6 text-green-600 dark:text-green-400"
                              })
                            ]),
                            _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "text-lg font-semibold" }, "Life Story Work", -1))
                          ]),
                          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-gray-600 dark:text-gray-400" }, " Develop meaningful life story work that captures a child's likes, dislikes, milestones, and everyday routines, creating lasting memories families can carry forward. ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Motion), {
                    as: "div",
                    initial: { opacity: 0, y: 20 },
                    "while-in-view": { opacity: 1, y: 0 },
                    viewport: { once: true },
                    transition: { duration: 0.4, delay: 0.4 }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UCard, { class: "p-6 hover:shadow-lg transition-all duration-300" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_UIcon, {
                                name: "i-heroicons-shield-check",
                                class: "h-6 w-6 text-purple-600 dark:text-purple-400"
                              })
                            ]),
                            _cache[6] || (_cache[6] = _createElementVNode("h3", { class: "text-lg font-semibold" }, "Regulatory Compliance", -1))
                          ]),
                          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-gray-600 dark:text-gray-400" }, " Meet National Minimum Standards for Residential Family Centres, ensuring both parents' and children's wishes and feelings are consistently heard and respected. ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Motion), {
                    as: "div",
                    initial: { opacity: 0, y: 20 },
                    "while-in-view": { opacity: 1, y: 0 },
                    viewport: { once: true },
                    transition: { duration: 0.4, delay: 0.5 }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UCard, { class: "p-6 hover:shadow-lg transition-all duration-300" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(_component_UIcon, {
                                name: "i-heroicons-users",
                                class: "h-6 w-6 text-orange-600 dark:text-orange-400"
                              })
                            ]),
                            _cache[8] || (_cache[8] = _createElementVNode("h3", { class: "text-lg font-semibold" }, "Family Connection", -1))
                          ]),
                          _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-gray-600 dark:text-gray-400" }, " Strengthen connections between parents, children, and professionals with tools designed to make families feel seen, supported, and encouraged during difficult times. ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(Motion), {
                    as: "div",
                    initial: { opacity: 0, y: 20 },
                    "while-in-view": { opacity: 1, y: 0 },
                    viewport: { once: true },
                    transition: { duration: 0.4, delay: 0.6 }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UCard, { class: "p-6 hover:shadow-lg transition-all duration-300" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_component_UIcon, {
                                name: "i-heroicons-document-text",
                                class: "h-6 w-6 text-indigo-600 dark:text-indigo-400"
                              })
                            ]),
                            _cache[10] || (_cache[10] = _createElementVNode("h3", { class: "text-lg font-semibold" }, "Secure Documentation", -1))
                          ]),
                          _cache[11] || (_cache[11] = _createElementVNode("p", { class: "text-gray-600 dark:text-gray-400" }, " All feedback forms and life story work are securely stored within parent and child profiles, creating clear, continuous records that inform assessments and reviews. ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createVNode(_unref(Motion), {
                as: "div",
                initial: { opacity: 0, y: 20 },
                "while-in-view": { opacity: 1, y: 0 },
                viewport: { once: true },
                transition: { duration: 0.4, delay: 0.3 },
                class: "mt-20"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_UPageSection, {
                    title: "Why Family Engagement Matters",
                    orientation: "horizontal",
                    description: "This feature helps services meet key regulatory standards while ensuring families feel heard, valued, and supported. More importantly, it creates meaningful records that parents and children can carry forward beyond the assessment period.",
                    align: "left",
                    ui: {
              container: 'flex flex-col lg:grid py-16 sm:py-24 lg:py-5 gap-8 sm:gap-16',
            }
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_unref(Motion), {
                          as: "div",
                          class: "relative",
                          initial: { opacity: 0, y: 20 },
                          "while-in-view": { opacity: 1, y: 0 },
                          viewport: { once: true },
                          transition: { duration: 0.4, delay: 0.1 }
                        }, {
                          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                            _createElementVNode("img", {
                              src: _imports_0,
                              alt: "Dad and child picture",
                              class: "w-full h-full rounded-lg",
                              loading: "lazy"
                            }, null, -1)
                          ]))]),
                          _: 1
                        }),
                        _createVNode(_unref(Motion), {
                          as: "div",
                          class: "relative",
                          initial: { opacity: 0, y: 20 },
                          "while-in-view": { opacity: 1, y: 0 },
                          viewport: { once: true },
                          transition: { duration: 0.4, delay: 0.2 }
                        }, {
                          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                            _createElementVNode("img", {
                              src: _imports_1,
                              alt: "My Story - Life story work",
                              class: "w-full h-auto rounded-lg",
                              loading: "lazy"
                            }, null, -1)
                          ]))]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_UPageHero, {
                  title: "Continue Your Journey",
                  description: "Explore more tools that work seamlessly with Family Engagement to create a comprehensive family assessment experience.",
                  ui: {
              container: 'py-8 sm:py-6 lg:py-6',
              title: 'text-4xl sm:text-4xl text-pretty tracking-tight font-bold',
            }
                }),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_LazyShowCaseCard, {
                    title: "Resident Profiles",
                    description: "A dedicated space for each resident, tracking their journey and needs with comprehensive profile management and progress monitoring.",
                    icon: "i-heroicons-user-circle",
                    image: "/howitworks/activate_resident.webp",
                    "image-position": "bottom",
                    link: "/more/resident-profiles",
                    class: "w-full md:w-4/7 h-110"
                  }),
                  _createVNode(_component_LazyShowCaseCard, {
                    title: "Direct Work",
                    description: "Customise and track direct work sessions with comprehensive tools for therapeutic interventions and family support.",
                    icon: "i-heroicons-clipboard-document-list",
                    image: "/images/dw_track.svg",
                    "image-position": "bottom",
                    link: "/more/direct-work",
                    class: "w-full md:w-3/7 h-110"
                  })
                ])
              ]),
              _createVNode(_component_LazyStartSignup)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})